import React, {  } from 'react';
import { InputNumber, Form, DatePicker } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';

dayjs.locale('ru');

export default function IzmenitDatiVozvratov(props) {
    const { object, form } = props;
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    dataVremya: (object && object.dataVremya) ? dayjs(object.dataVremya) : undefined,
                }}
            >
                <Form.Item
                    label={"Дата"}
                    name={"dataVremya"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите дату!' }]}
                >
                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                </Form.Item>
                <Form.Item
                    label={"Процент к возврату"}
                    name={"protsent"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите процент к возврату!' }]}
                >
                    <InputNumber min={1} />
                </Form.Item>
            </Form>
        </>
    );
}
